export enum enumBillStatus {
  QUOTE,
  SHIPPING_ORDER,
  DRAFT,
  FINALIZED,
}
